import { api } from './client';

export interface PlayerAggregate {
  name: string;
  first_seen: string;
  last_seen: string;
  total_duration_s: number;
}

export interface SessionsResponse {
  players: PlayerAggregate[];
  from: string;
  to: string;
}

export const fetchGameSessions = (
  id: string,
  from?: string,
  to?: string,
): Promise<SessionsResponse> =>
  api
    .get<SessionsResponse>(`/games/${id}/sessions`, { params: { from, to } })
    .then((r) => r.data);
